import FixFlickity from "//legramme.com/cdn/shop/t/78/assets/ftdomflickity-fix.js?v=95405438931270853161773307043";

export class InfosProductSection extends HTMLElement {
    connectedCallback() {
      this.infosSection        = this.querySelector('.infos-section__product-images-slider');
      this.SliderTitle         = this.querySelector('.infos-section__slider .infos-section__title');
      this.infosVideo          = document.querySelectorAll('.links-blocs-video');

      this._attachListeners();

      this.intersectionObserver = new IntersectionObserver(this._initVideo.bind(this));
      this.intersectionObserver.observe(this);

      this.intersectionObserverSlider = new IntersectionObserver(this._initSliders.bind(this));
      this.intersectionObserverSlider.observe(this);

      this.intersectionObserverSticky = new IntersectionObserver(this._initSticky.bind(this));
      this.intersectionObserverSticky.observe(this);

      new FixFlickity();

    }

    _attachListeners() {
        window.addEventListener('resize', this._responsiveContent.bind(this));
    }

   /**
   * SLIDERS
   */
  _initSliders(entries, intersectionObserverSlider) {

    if (!entries[0].isIntersecting) {
      return;
    }

    intersectionObserverSlider.disconnect();

    // fix Flickity slider
    if (this.infosSection) {
      this.mainslider = new Flickity(this.infosSection, {
        cellAlign: 'left',
        groupCells: true,
        contain: true,
        wrapAround: true,
        pageDots: false,
        arrowShape: 'M6.5 1.5L1.5 8L6.5 14.5',
        arrowViewBox: '0 0 8 16',
        on: {
          ready: function() {
            // wrap buttons
            let sliderNavContainer = document.querySelector('.infos-section__slider-nav-container');
            if (sliderNavContainer) {
              sliderNavContainer.appendChild(this.prevButton.element);
              sliderNavContainer.appendChild(this.nextButton.element);
            }
          }
        }
      });

      let that = this;
      setTimeout(function() {
        that.mainslider.resize();
      }, 300);

    }

    Flickity.prototype._createResizeClass = function() {
       this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    let resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call(this);
      this.element.classList.add('flickity-resize');
    };
  }


   /**
   * DEFINE STICKY BOTTOM
   */
  _initSticky(entries, intersectionObserverSticky) {

    if (!entries[0].isIntersecting) {
      return;
    }

    intersectionObserverSticky.disconnect();
    
    let stickyLeft             = this.querySelector('.infos-section__left');
    
    if (stickyLeft) {
      let stickyLeftTop             = this.querySelector('.infos-section__left .infos-column__sticky-top');
      let stickyLeftBottom1         = this.querySelector('.infos-section__left .infos-column--2 .infos-column__sticky-bottom');
      let stickyLeftBottom2         = this.querySelector('.infos-section__left .infos-column--3 .infos-column__sticky-bottom');
      let stickyLeftTopHeight       = 0;
      let stickyLeftBottomHeight1   = 0;
      let stickyLeftBottomHeight2   = 0;
      let stickyLeftCss             = 0;

      if (stickyLeftTop) {
        stickyLeftTopHeight = stickyLeftTop.offsetHeight;
      }
      if (stickyLeftBottom1) {
        stickyLeftBottomHeight1 = stickyLeftBottom1.offsetHeight;
      }
      if (stickyLeftBottom2) {
        stickyLeftBottomHeight2 = stickyLeftBottom2.offsetHeight;
      }
      if (stickyLeftBottomHeight1 > stickyLeftBottomHeight2) {
        stickyLeftCss     = stickyLeftBottomHeight2 - stickyLeftTopHeight - 160;
        stickyLeftBottom2.classList.add('stickybottom');
      } else {
        stickyLeftCss     = stickyLeftBottomHeight1 - stickyLeftTopHeight - 160;
        stickyLeftBottom1.classList.add('stickybottom');
      }
      
      this.style.setProperty("--sticky-left","-"+stickyLeftCss+"px");
    }

    let stickyRight             = this.querySelector('.infos-section__right');
    
    if (stickyRight) {

      let stickyRightTop            = this.querySelector('.infos-section__right .infos-column__sticky-top');
      let stickyRightBottom1        = this.querySelector('.infos-section__right .infos-column--1 .infos-column__sticky-bottom');
      let stickyRightBottom2        = this.querySelector('.infos-section__right .infos-column--2 .infos-column__sticky-bottom');
      let stickyRightTopHeight      = 0;
      let stickyRightBottomHeight1  = 0;
      let stickyRightBottomHeight2  = 0;
      let stickyRightCss            = 0;

      if (stickyRightTop) {
        stickyRightTopHeight = stickyRightTop.offsetHeight;
      }
      if (stickyRightBottom1) {
        stickyRightBottomHeight1 = stickyRightBottom1.offsetHeight;
      }
      if (stickyRightBottom2) {
        stickyRightBottomHeight2 = stickyRightBottom2.offsetHeight;
      }

      if (stickyRightBottomHeight1 > stickyRightBottomHeight2) {
        stickyRightCss    = stickyRightBottomHeight2 - stickyRightTopHeight - 160;
        stickyRightBottom2.classList.add('stickybottom');
      } else {
        stickyRightCss    = stickyRightBottomHeight1 - stickyRightTopHeight - 160
        stickyRightBottom1.classList.add('stickybottom');
      }

      this.style.setProperty("--sticky-right","-"+Math.abs(stickyRightCss)+"px")
    }

  }

  /**
     * INIT VIDEO FROM IFRAME
     */
  _initVideo(entries, intersectionObserver) {

    if (!entries[0].isIntersecting) {
      return;
    }

    intersectionObserver.disconnect();

    this.infosVideo.forEach(function(value, index) {
      value.setAttribute('src', value.getAttribute('data-src'));
    });
  }

  /**
     * Manage responsive content
     */
  _responsiveContent() {
    this.intersectionObserverSticky = new IntersectionObserver(this._initSticky.bind(this));
    this.intersectionObserverSticky.observe(this);
  }

}
try {
    window.customElements.define('infos-section', InfosProductSection);
  } catch(e) {}

